export type ConfirmOptions = {
  title: string;
  text?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
};

type ConfirmRequest = ConfirmOptions & {
  resolve: (confirmed: boolean) => void;
};

let listener: ((request: ConfirmRequest) => void) | null = null;

export const confirmDialog = {
  subscribe(fn: (request: ConfirmRequest) => void) {
    listener = fn;
  },
  unsubscribe() {
    listener = null;
  },
  open(options: ConfirmOptions): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (!listener) {
        const msg = options.text ? `${options.title}\n${options.text}` : options.title;
        resolve(window.confirm(msg));
        return;
      }
      listener({ ...options, resolve });
    });
  },
};
